import { useState, useEffect } from 'react';
import { axiosDummyInstance, axiosScraper } from '@utils/axios/axiosInstance';
import LoaderComponent from '@components/atom/layout/loader';
import { FadeLoader } from 'react-spinners';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { IResponseRegisteredAppInfo } from '@models/manager/service/serviceModel';

interface IProps {
  selectedMyApp: IResponseRegisteredAppInfo;
  selectedCompetitorAppList: IResponseRegisteredAppInfo[];
  onClickSelectApp: (appObj: IResponseRegisteredAppInfo) => void;
}

type requestParamType = {
  appObj: IResponseRegisteredAppInfo;
  country: string;
};

const SuggestAppList = ({ selectedMyApp, selectedCompetitorAppList, onClickSelectApp }: IProps) => {
  const { myAppInfoList, countryCode } = useSelector(({ serviceManager }: RootState) => serviceManager);

  // suggestedResponsedDataList
  const [suggestAppList, setSuggestAppList] = useState(null);

  // useEffect for request SuggestDataList
  useEffect(() => {
    // scrapper request function
    const requestSuggestCompetitorApps = async (params: requestParamType) => {
      const { status, data, statusText } = await axiosScraper.post('/axo/suggestApps', params);
      if (status === 200) {
        return data;
      } else {
        return new Error(statusText);
      }
    };

    if (selectedMyApp) {
      console.log('selectedMyApp: ', selectedMyApp);
      requestSuggestCompetitorApps({
        appObj: selectedMyApp,
        country: countryCode.toLowerCase(),
      })
        .then((data) => setSuggestAppList(data))
        .catch((error) => alert(error));
    }
  }, []);

  return (
    <div className="umanager-search">
      <h3 className="umanager-tit">Competitor Apps Suggest</h3>
      <div className="umanager-result">
        {suggestAppList?.length > 0 ? (
          <ul className="manager-list">
            {/* TODO: 목록이 많아서 일단은 임시로 10개만 걸어둠.. 추후 그리드 안에 넣는 방법도 고려해야함 */}
            {suggestAppList.slice(0, 10).map((item, index) => (
              <li key={index}>
                <div className="manager-list-img">
                  <img src={item.icon} alt="" />
                </div>
                <div className="manager-list-txt">
                  <span className="manager-list-tit">{item.title}</span>
                  <span className="manager-list-dsc">{item.developer}</span>
                </div>
                <span className="manager-list-chk">
                  <input
                    type="checkbox"
                    className="ipt-check"
                    id={`checked-${index}`}
                    checked={
                      selectedCompetitorAppList.findIndex((stateObj) => stateObj.appId === item.appId) > -1
                        ? true
                        : false
                    }
                    onChange={() => onClickSelectApp(item)}
                  />
                  <label htmlFor={`checked-${index}`}>
                    <span className="blind">선택</span>
                  </label>
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <LoaderComponent height={'100px'}>
            <FadeLoader />
          </LoaderComponent>
        )}
      </div>
    </div>
  );
};

export default SuggestAppList;
